import { v4 as uuidv4 } from 'uuid';

export default defineNuxtRouteMiddleware(async (to, from) => {
  const sessionOrientation = useNomadStorage('orienation', uuidv4());
  if (!from.path.includes('/orientation') && to.path.includes('/orientation')) {
    sessionOrientation.value = uuidv4();
  }
});
